export const TableSkeleton = () => (
    <div className="animate-pulse space-y-3 p-4">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className="h-14 bg-brand-border/50 rounded-xl" />
      ))}
    </div>
  );
  
  export const StatsSkeleton = () => (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 animate-pulse">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="h-24 bg-brand-border/50 rounded-2xl" />
      ))}
    </div>
  );
  